import { apiDelete, apiGet } from "./apiClient";

function asArray(value) {
  if (Array.isArray(value)) return value;
  if (value && Array.isArray(value.items)) return value.items;
  if (value && Array.isArray(value.data)) return value.data;
  return [];
}

/** GET `/api/Categories` — matches CategoriesController.GetAll */
export const CATEGORIES_API = "/api/Categories";
/** GET `/api/Brands` */
export const BRANDS_API = "/api/Brands";
/** GET `/api/Attributes` */
export const ATTRIBUTES_API = "/api/Attributes";
/** GET `/api/AttributeValues` */
export const ATTRIBUTE_VALUES_API = "/api/AttributeValues";

function num(x, d = 0) {
  const n = typeof x === "number" ? x : Number(x);
  return Number.isFinite(n) ? n : d;
}

export function normalizeCategory(row) {
  if (!row || typeof row !== "object") return null;
  const id = row.id ?? row.Id;
  if (id == null) return null;
  return {
    id,
    parentId: row.parentId ?? row.ParentId ?? null,
    name: row.name ?? row.Name ?? "",
    slug: row.slug ?? row.Slug ?? "",
    image: row.image ?? row.Image ?? "",
    icon: row.icon ?? row.Icon ?? "",
    order: num(row.order ?? row.Order, 0),
    isActive: Boolean(row.isActive ?? row.IsActive),
    isFeatured: Boolean(row.isFeatured ?? row.IsFeatured),
    metaTitile: row.metaTitile ?? row.MetaTitile ?? "",
    metaDescription: row.metaDescription ?? row.MetaDescription ?? ""
  };
}

export function normalizeBrand(row) {
  if (!row || typeof row !== "object") return null;
  const id = row.id ?? row.Id;
  if (id == null) return null;
  return {
    id,
    parentId: row.parentId ?? row.ParentId ?? null,
    name: row.name ?? row.Name ?? "",
    slug: row.slug ?? row.Slug ?? "",
    logo: row.logo ?? row.Logo ?? "",
    banner: row.banner ?? row.Banner ?? "",
    description: row.description ?? row.Description ?? "",
    metaTitile: row.metaTitile ?? row.MetaTitile ?? "",
    metaDescription: row.metaDescription ?? row.MetaDescription ?? ""
  };
}

export function normalizeAttribute(row) {
  if (!row || typeof row !== "object") return null;
  const id = row.id ?? row.Id;
  if (id == null) return null;
  return {
    id,
    name: row.name ?? row.Name ?? "",
    slug: row.slug ?? row.Slug ?? "",
    isFilterable: Boolean(row.isFilterable ?? row.IsFilterable),
    isVarient: Boolean(row.isVarient ?? row.IsVarient)
  };
}

export function normalizeAttributeValue(row) {
  if (!row || typeof row !== "object") return null;
  const id = row.id ?? row.Id;
  if (id == null) return null;
  return {
    id,
    attributeId: row.attributeId ?? row.AttributeId,
    value: row.value ?? row.Value ?? "",
    colorCode: row.colorCode ?? row.ColorCode ?? "",
    order: num(row.order ?? row.Order, 0)
  };
}

export async function fetchCategoriesList() {
  const res = await apiGet(CATEGORIES_API);
  if (!res.ok) return { ok: false, items: [], error: res.error ?? "Failed to load categories" };
  const items = asArray(res.data).map(normalizeCategory).filter(Boolean);
  return { ok: true, items, error: null };
}

export async function fetchBrandsList() {
  const res = await apiGet(BRANDS_API);
  if (!res.ok) return { ok: false, items: [], error: res.error ?? "Failed to load brands" };
  const items = asArray(res.data).map(normalizeBrand).filter(Boolean);
  return { ok: true, items, error: null };
}

export async function fetchAttributesList() {
  const res = await apiGet(ATTRIBUTES_API);
  if (!res.ok) return { ok: false, items: [], error: res.error ?? "Failed to load attributes" };
  const items = asArray(res.data).map(normalizeAttribute).filter(Boolean);
  return { ok: true, items, error: null };
}

export async function fetchAttributeValuesListView() {
  const [vRes, aRes] = await Promise.all([apiGet(ATTRIBUTE_VALUES_API), apiGet(ATTRIBUTES_API)]);
  const values = asArray(vRes.ok ? vRes.data : null).map(normalizeAttributeValue).filter(Boolean);
  const attributes = asArray(aRes.ok ? aRes.data : null).map(normalizeAttribute).filter(Boolean);
  const ok = Boolean(vRes.ok);
  const error = !vRes.ok ? (vRes.error ?? "Failed to load attribute values") : null;
  return { ok, values, attributes, error };
}

/** GET `/api/AttributeValues/by-attribute/{id}` */
export async function fetchAttributeValuesByAttributeId(attributeId) {
  const res = await apiGet(`${ATTRIBUTE_VALUES_API}/by-attribute/${attributeId}`);
  if (!res.ok) return { ok: false, items: [], error: res.error ?? "Failed to load attribute values" };
  const items = asArray(res.data).map(normalizeAttributeValue).filter(Boolean);
  return { ok: true, items, error: null };
}

export function deleteCategory(id) {
  return apiDelete(`${CATEGORIES_API}/${id}`);
}

export function deleteBrand(id) {
  return apiDelete(`${BRANDS_API}/${id}`);
}

export function deleteAttribute(id) {
  return apiDelete(`${ATTRIBUTES_API}/${id}`);
}

export function deleteAttributeValue(id) {
  return apiDelete(`${ATTRIBUTE_VALUES_API}/${id}`);
}
